export default __webpack_public_path__ + "static/media/Newsletter 011.ca072f88.png";